module.exports = __webpack_public_path__ + "static/media/Hand-and-phone-in-front-of-eiffel-tower_Ilias-Chebbi.e7662f62.jpg";